<template>
  <div
    class="modal fade"
    id="sms-notifications"
    tabindex="-1"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <div class="modal-content">
        <div class="modal-body">
          <LoadingElement v-if="loading" />
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            id="notifications-sms-close"
          ></button>
          <div class="text-center">
            <h4 class="mb-8">{{ $t("notifications.type.sms") }}</h4>
          </div>
          <div class="row border gap-y-4 p-4">
            <div class="col-12 font-bold text-xl">
              {{ $t("notifications.config.service") }}
            </div>
            <div class="col-md-4">
              <label for="form-label">{{
                $t("notifications.config.disabled")
              }}</label>
              <input
                type="radio"
                class="form-check-input"
                v-model="notifications.sms_notifications_service"
                value="disabled"
              />
            </div>
            <div class="col-md-4">
              <label for="form-label">Syriatel</label>
              <input
                type="radio"
                class="form-check-input"
                v-model="notifications.sms_notifications_service"
                value="syriatel"
              />
            </div>
            <div class="col-md-4">
              <label for="form-label">MTN</label>
              <input
                type="radio"
                class="form-check-input"
                disabled
                v-model="notifications.sms_notifications_service"
                value="mtn"
              />
            </div>
            <div class="col-md-4">
              <label for="form-label">SSRadius</label>
              <input
                type="radio"
                class="form-check-input"
                v-model="notifications.sms_notifications_service"
                value="ssradius"
              />
            </div>
          </div>
          <div
            class="row border gap-y-4 p-4"
            v-if="notifications.sms_notifications_service != 'ssradius'"
          >
            <div class="col-md-4">
              <label class="form-label">{{
                $t("notifications.config.sms_username")
              }}</label>
              <input
                type="text"
                class="form-control"
                autocomplete="one-time-code"
                v-model="notifications.sms_username"
              />
            </div>
            <div class="col-md-4">
              <label class="form-label">{{
                $t("notifications.config.sms_password")
              }}</label>
              <input
                type="password"
                class="form-control"
                autocomplete="one-time-code"
                v-model="notifications.sms_password"
              />
            </div>
            <div class="col-md-4">
              <label class="form-label">{{
                $t("notifications.config.sms_sender")
              }}</label>
              <input
                type="text"
                class="form-control"
                autocomplete="one-time-code"
                v-model="notifications.sms_from"
              />
            </div>
          </div>
          <div v-else class="row border gap-y-4 p-4">
            <div class="col-md-8">
              <label class="form-label">{{
                $t("notifications.config.sms_network_identifier")
              }}</label>
              <input
                type="text"
                class="form-control"
                autocomplete="one-time-code"
                v-model="notifications.sms_network_identifier"
                placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
              />
            </div>
            <div class="col-md-4">
              <label class="form-label">{{
                $t("notifications.config.sms_sender")
              }}</label>
              <input
                type="text"
                class="form-control"
                autocomplete="one-time-code"
                :value="sms_stats.sender_name"
                disabled
              />
            </div>
          </div>

          <div
            class="row border gap-y-4 p-4"
            v-if="hasPrivilege('settings_sms_messages')"
          >
            <div
              class="row"
              v-if="
                notifications.sms_expiration_message_enabled ||
                  notifications.sms_expiring_soon_message_enabled ||
                  notifications.sms_renew_message_enabled ||
                  notifications.sms_sham_renew_message_enabled
              "
            >
              <div class="col-12">
                <h5>{{ $t("notifications.config.available_variables") }}</h5>
                <p class="text-muted">
                  {{ $t("notifications.config.variables_note") }}
                </p>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{
                  $t("notifications.config.username")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    value="{username}"
                    type="text"
                    class="form-control"
                    disabled
                    id="username-input"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="copyToClip('username-input')"
                  >
                    <i class="ti ti-copy ti-s "></i>
                  </button>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{
                  $t("notifications.config.fullname")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    value="{full_name}"
                    type="text"
                    class="form-control"
                    disabled
                    id="fullname-input"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="copyToClip('fullname-input')"
                  >
                    <i class="ti ti-copy ti-s "></i>
                  </button>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{
                  $t("notifications.config.profile_name")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    value="{profile}"
                    type="text"
                    class="form-control"
                    disabled
                    id="profile-input"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="copyToClip('profile-input')"
                  >
                    <i class="ti ti-copy ti-s "></i>
                  </button>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{
                  $t("notifications.config.profile_price")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    value="{price}"
                    type="text"
                    class="form-control"
                    disabled
                    id="price-input"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="copyToClip('price-input')"
                  >
                    <i class="ti ti-copy ti-s "></i>
                  </button>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{
                  $t("notifications.config.paid_amount")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    value="{paid_amount}"
                    type="text"
                    class="form-control"
                    disabled
                    id="paid-amount-input"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="copyToClip('paid-amount-input')"
                  >
                    <i class="ti ti-copy ti-s "></i>
                  </button>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{
                  $t("notifications.config.debt")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    value="{debt}"
                    type="text"
                    class="form-control"
                    disabled
                    id="debt-input"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="copyToClip('debt-input')"
                  >
                    <i class="ti ti-copy ti-s "></i>
                  </button>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{
                  $t("notifications.config.discount")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    value="{discount}"
                    type="text"
                    class="form-control"
                    disabled
                    id="discount-input"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="copyToClip('discount-input')"
                  >
                    <i class="ti ti-copy ti-s "></i>
                  </button>
                </div>
              </div>

              <div class="col-md-6">
                <label class="form-label">{{
                  $t("notifications.config.total_debts")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    value="{total_debt}"
                    type="text"
                    class="form-control"
                    disabled
                    id="total-debts-input"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="copyToClip('total-debts-input')"
                  >
                    <i class="ti ti-copy ti-s "></i>
                  </button>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{
                  $t("notifications.config.invoice_number")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    value="{invoice_number}"
                    type="text"
                    class="form-control"
                    disabled
                    id="invoice-input"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="copyToClip('invoice-input')"
                  >
                    <i class="ti ti-copy ti-s "></i>
                  </button>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{
                  $t("notifications.config.sham_cash_code")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    value="{shamcode}"
                    type="text"
                    class="form-control"
                    disabled
                    id="shamcode-input"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="copyToClip('shamcode-input')"
                  >
                    <i class="ti ti-copy ti-s "></i>
                  </button>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{
                  $t("notifications.config.expires_at")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    value="{expires_at}"
                    type="text"
                    class="form-control"
                    disabled
                    id="expires-at-input"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="copyToClip('expires-at-input')"
                  >
                    <i class="ti ti-copy ti-s "></i>
                  </button>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{
                  $t("notifications.config.network_name")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    value="{network_name}"
                    type="text"
                    class="form-control"
                    disabled
                    id="network-name-input"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="copyToClip('network-name-input')"
                  >
                    <i class="ti ti-copy ti-s "></i>
                  </button>
                </div>
              </div>
              <div>
                {{
                  $t("notifications.config.do_not_put_links_inside_the_message")
                }}
              </div>
            </div>
            <div class="col-12">
              <label
                class="form-check-label custom-option-content"
                for="opspeed"
              >
                <input
                  name="openprofilespeed"
                  class="form-check-input"
                  type="checkbox"
                  v-model="notifications.sms_expiration_message_enabled"
                />
                {{ $t("notifications.config.expiration_message") }}
              </label>
              <textarea
                v-if="notifications.sms_expiration_message_enabled"
                class="form-control mt-2"
                rows="3"
                v-model="notifications.sms_expiration_message"
                :class="{ 'is-invalid': errors.custom_expiration_length }"
                @input="validate"
              ></textarea>
              <div
                v-if="notifications.sms_expiration_message_enabled"
                class="text-end text-muted"
                :class="{ 'invalid-feedback': errors.custom_expiration_length }"
              >
                60/{{ notifications.sms_expiration_message.length }}
              </div>
            </div>
            <div class="col-12">
              <label
                class="form-check-label custom-option-content"
                for="opspeed"
              >
                <input
                  name="openprofilespeed"
                  class="form-check-input"
                  type="checkbox"
                  v-model="notifications.sms_renew_message_enabled"
                />
                {{ $t("notifications.config.renew_message") }}
              </label>
              <textarea
                v-if="notifications.sms_renew_message_enabled"
                class="form-control mt-2"
                rows="3"
                v-model="notifications.sms_renew_message"
                :class="{ 'is-invalid': errors.custom_renew_length }"
                @input="validate"
              ></textarea>
              <div
                v-if="notifications.sms_renew_message_enabled"
                class="text-end text-muted"
                :class="{ 'invalid-feedback': errors.custom_renew_length }"
              >
                60/{{ notifications.sms_renew_message.length }}
              </div>
            </div>
            <div class="col-12">
              <label
                class="form-check-label custom-option-content"
                for="opspeed"
              >
                <input
                  name="openprofilespeed"
                  class="form-check-input"
                  type="checkbox"
                  v-model="notifications.sms_expiring_soon_message_enabled"
                />
                {{ $t("notifications.config.expiring_soon_message") }}
              </label>
              <textarea
                v-if="notifications.sms_expiring_soon_message_enabled"
                class="form-control mt-2"
                rows="3"
                v-model="notifications.sms_expiring_soon_message"
                :class="{ 'is-invalid': errors.custom_expiring_soon_length }"
                @input="validate"
              ></textarea>
              <div
                v-if="notifications.sms_expiring_soon_message_enabled"
                class="text-end text-muted"
                :class="{
                  'invalid-feedback': errors.custom_expiring_soon_length,
                }"
              >
                60/{{ notifications.sms_expiring_soon_message.length }}
              </div>
            </div>
            <div class="col-12">
              <label
                class="form-check-label custom-option-content"
                for="opspeed"
              >
                <input
                  name="openprofilespeed"
                  class="form-check-input"
                  type="checkbox"
                  v-model="notifications.sms_sham_renew_message_enabled"
                />
                {{ $t("notifications.config.sham_renew_message") }}
              </label>
              <textarea
                v-if="notifications.sms_sham_renew_message_enabled"
                class="form-control mt-2"
                rows="3"
                v-model="notifications.sms_sham_renew_message"
                :class="{ 'is-invalid': errors.custom_sham_renew_length }"
                @input="validate"
              ></textarea>
              <div
                v-if="notifications.sms_sham_renew_message_enabled"
                class="text-end text-muted"
                :class="{ 'invalid-feedback': errors.custom_sham_renew_length }"
              >
                60/{{ notifications.sms_sham_renew_message.length }}
              </div>
            </div>
          </div>
          <div
            v-if="notifications.sms_notifications_service == 'ssradius'"
            class="row border gap-y-4 p-4"
          >
            <div class="grid grid-cols-6 gap-4">
              <div class="col-span-6 font-bold text-xl text-center">
                {{ $t("notifications.raselsms.ssradius_sms_stats") }}
              </div>
              <div
                class="flex flex-col justify-center align-items-center col-span-2"
                :class="{ 'text-success font-bold': sms_stats.activated }"
              >
                <div class="text-muted">
                  {{ $t("notifications.raselsms.activated") }}
                </div>
                <div>
                  {{
                    sms_stats.activated ? $t("control.yes") : $t("control.no")
                  }}
                </div>
              </div>
              <div
                class="flex flex-col justify-center align-items-center col-span-2"
              >
                <div class="text-muted">
                  {{ $t("notifications.raselsms.charged_messages") }}
                </div>
                <div>{{ sms_stats.charged_messages }}</div>
              </div>
              <div
                class="flex flex-col justify-center align-items-center col-span-2"
              >
                <div class="text-muted">
                  {{ $t("notifications.raselsms.remaining_messages") }}
                </div>
                <div>{{ sms_stats.remaining_messages }}</div>
              </div>
              <div
                class="flex flex-col justify-center align-items-center col-span-3"
              >
                <div class="text-muted">
                  {{ $t("notifications.raselsms.total_success") }}
                </div>
                <div>{{ sms_stats.total_success }}</div>
              </div>
              <div
                class="flex flex-col justify-center align-items-center col-span-3"
              >
                <div class="text-muted">
                  {{ $t("notifications.raselsms.total_failed") }}
                </div>
                <div>{{ sms_stats.total_failed }}</div>
              </div>
              <div
                class="flex flex-col justify-center align-items-center col-span-3"
              >
                <div class="text-muted">
                  {{ $t("notifications.raselsms.current_month_success") }}
                </div>
                <div>{{ sms_stats.monthly_success }}</div>
              </div>
              <div
                class="flex flex-col justify-center align-items-center col-span-3"
              >
                <div class="text-muted">
                  {{ $t("notifications.raselsms.current_month_failed") }}
                </div>
                <div>{{ sms_stats.monthly_failed }}</div>
              </div>
            </div>
          </div>
          <div class="row mt-6">
            <div class="col-12 text-center">
              <button
                class="btn btn-primary"
                @click.prevent="store"
                :disabled="!validated || loading"
              >
                {{ $t("control.save") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import QrcodeVue from "qrcode.vue";
import { hasPrivilege } from "../../global_constants";

export default {
  name: "notificationsSms",
  data() {
    return {
      qr: null,
      loading: false,
      status: "",
      notifications: {
        sms_username: "",
        sms_password: "",
        sms_from: "",
        sms_network_identifier: "",
        sms_expiration_message:
          " عزيزي المشترك {username} انتهى اشتراكك في شبكتنا",
        sms_expiration_message_enabled: false,
        sms_expiring_soon_message:
          "عزيزي المشترك {username} سينتهي اشتراكك بتاريخ {expires_at}",
        sms_expiring_soon_message_enabled: false,
        sms_renew_message:
          "عزيزي المشترك {username} تم تجديد اشتراكك {profile} بنجاح",
        sms_renew_message_enabled: false,
        sms_sham_renew_message:
          "عزيزي المشترك {username} تم تجديد الاشتراك عن طريق شام كاش",
        sms_sham_renew_message_enabled: false,
        sms_notifications_service: "disabled",
      },
      instance: {
        instance: "",
      },
      sms_stats: {
        activated: false,
        charged_messages: 0,
        remaining_messages: 0,
        total_success: 0,
        total_failed: 0,
        monthly_success: 0,
        monthly_failed: 0,
        sender_id_in_use: false,
        sender_name: "SSRadius",
      },
      instance_error: null,
      validated: true,
      errors: {
        expired: null,
        expiring: null,
        custom_expiration_length: null,
        custom_expiring_soon_length: null,
        custom_renew_length: null,
        custom_sham_renew_length: null,
        renew: null,
      },
      inside_page: true,
      showDeleteWa: false,
      text_direction:
        this.$i18n.locale == "ar" ? "direction:rtl" : "direction:ltr",
    };
  },
  computed: {
    ...mapGetters(["user", "settings"]),
  },

  async created() {
    await this.fetchSettings();
    await this.fetchRaselSmsStats();
  },
  watch: {
    $route(to, from) {
      this.inside_page = false;
    },
  },
  methods: {
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    async getQr() {
      // this.loading = true;
      var res = await axios.get("wa/qr");
      if (res.status == 200) {
        this.qr = res.data.qr_code;
      }
      // this.loading = false;
    },
    async statusCheck() {
      var response = await axios.get("wa/status");
      if (response.status == 200) {
        if (response.data.status == "open") this.status = "session_connected";
        else this.status = "qr";
        if (this.status == "browser tab closed")
          this.status = "session_not_found";
      } else if (response.status == 210) {
        this.status = "no_instance";
      }

      //this.status = "no_instance";
    },
    async deleteWa() {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text: this.$t(
          "notifications.this_will_delete_whatsapp_key_and_disconnect_it",
        ),
        icon: "error",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_delete_it"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            var response = await axios.post("wa/clear");

            this.$swal({
              title: this.$t("control.delete"),
              text: this.$t("notifications.whatsapp_key_deleted"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
            if (response.status == 200) {
              location.reload();
            }
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async fetchSettings() {
      this.loading = true;
      const response = await axios.get("sms/notifications");
      if (response.status == 200) {
        var temp = response.data.data;
        temp.forEach((element) => {
          switch (element.key) {
            case "sms_notifications_password":
              this.notifications.sms_password = element.value;
              break;
            case "sms_notifications_username":
              this.notifications.sms_username = element.value;
              break;
            case "sms_notifications_from":
              this.notifications.sms_from = element.value;
              break;
            case "sms_notifications_expiration_message":
              this.notifications.sms_expiration_message = element.value;
              if (element.value != null)
                this.notifications.sms_expiration_message_enabled = true;
              break;
            case "sms_notifications_service":
              this.notifications.sms_notifications_service = element.value;
              break;
            case "sms_notifications_network_identifier":
              this.notifications.sms_network_identifier = element.value;
              break;
            case "sms_notifications_renew_message":
              this.notifications.sms_renew_message = element.value;
              if (element.value != null)
                this.notifications.sms_renew_message_enabled = true;
              break;
            case "sms_notifications_expiring_soon_message":
              this.notifications.sms_expiring_soon_message = element.value;
              if (element.value != null)
                this.notifications.sms_expiring_soon_message_enabled = true;
              break;
            case "sms_notifications_sham_renew_message":
              this.notifications.sms_sham_renew_message = element.value;
              if (element.value != null)
                this.notifications.sms_sham_renew_message_enabled = true;
              break;
            default:
              break;
          }
        });
      }
      this.loading = false;
    },
    async fetchRaselSmsStats() {
      if (this.notifications.sms_notifications_service != "ssradius") {
        return;
      }
      this.loading = true;
      const response = await axios.post("sms/ssradius/stats");
      if (response.status == 200) {
        this.sms_stats.activated = true;
        this.sms_stats.charged_messages =
          response.data.data.balance.charged_messages;
        this.sms_stats.remaining_messages =
          response.data.data.balance.remaining_messages;
        this.sms_stats.total_success =
          response.data.data.messages_stats.total_success;
        this.sms_stats.total_failed =
          response.data.data.messages_stats.total_failed;
        this.sms_stats.monthly_success =
          response.data.data.messages_stats.current_month_success;
        this.sms_stats.monthly_failed =
          response.data.data.messages_stats.current_month_failed;
        this.sms_stats.sender_id_in_use =
          response.data.data.network.sender_id_in_use;
        if (this.sms_stats.sender_id_in_use) {
          await this.fetchRaselSmsSender();
        }
      } else if (response.status == 210) {
        console.log("failed to fetch stats");
      }
      this.loading = false;
    },
    async fetchRaselSmsSender() {
      if (this.notifications.sms_notifications_service != "ssradius") {
        return;
      }
      this.loading = true;
      const response = await axios.post("sms/ssradius/sender");
      if (response.status == 200) {
        this.sms_stats.sender_name = response.data.data.data.sender_name;
      } else if (response.status == 210) {
        console.log("failed to fetch stats");
      }
      this.loading = false;
    },
    async store() {
      this.loading = true;
      if (!this.notifications.sms_renew_message_enabled) {
        this.notifications.sms_renew_message = null;
      }
      if (!this.notifications.sms_expiration_message_enabled) {
        this.notifications.sms_expiration_message = null;
      }
      if (!this.notifications.sms_expiring_soon_message_enabled) {
        this.notifications.sms_expiring_soon_message = null;
      }
      if (!this.notifications.sms_sham_renew_message_enabled) {
        this.notifications.sms_sham_renew_message = null;
      }
      const response = await axios.post(
        "sms/notifications",
        this.notifications,
      );
      if (response.status == 200) {
        this.$notify({
          text: this.$t("messages.sms_settings_updated_successfully"),
          type: "success",
        });
        this.fetchRaselSmsStats();
      }
      this.loading = false;
    },
    async instanceCheck() {
      this.loading = true;
      const response = await axios.post("wa/instance", this.instance);
      if (response.status == 200) {
        this.$swal({
          title: this.$t("notifications.wa.license_validated"),
          icon: "success",
        });
        location.reload();
      } else if (response.status == 210) {
        this.instance_error = this.$t(
          `errors.notifications.wa.license_not_valid`,
        );
      }
      this.loading = false;
    },
    async updateStatus() {
      this.statusCheck();
      if (this.status == "session_not_connected") this.getQr();
    },
    copyToClip(id) {
      // Get the text field
      var copyText = document.getElementById(id);

      // Select the text field
      copyText.select();
      copyText.setSelectionRange(0, 99999); // For mobile devices

      // Copy the text inside the text field
      navigator.clipboard.writeText(copyText.value);
      this.$notify({
        text: this.$t("control.copied_to_clipboard"),
        type: "info",
      });
    },
    validate() {
      this.validated = true;
      this.errors.expired = null;
      this.errors.expiring = null;
      this.errors.renew = null;
      this.errors.custom_expiration_length = null;
      this.errors.custom_expiring_soon_length = null;
      this.errors.custom_renew_length = null;
      this.errors.custom_sham_renew_length = null;
      var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
      if (
        this.notifications.sms_expiration_message.includes(".") ||
        this.notifications.sms_expiration_message.includes("http")
      ) {
        this.errors.custom_expiration_length = this.$t(
          "errors.notifications.wa.url",
        );
        this.validated = false;
      }
      if (
        this.notifications.sms_expiring_soon_message.includes(".") ||
        this.notifications.sms_expiring_soon_message.includes("http")
      ) {
        this.errors.custom_expiring_soon_length = this.$t(
          "errors.notifications.wa.url",
        );
        this.validated = false;
      }
      if (
        this.notifications.sms_renew_message.includes(".") ||
        this.notifications.sms_renew_message.includes("http")
      ) {
        this.errors.custom_renew_length = this.$t(
          "errors.notifications.wa.url",
        );
        this.validated = false;
      }

      if (
        this.notifications.sms_expiration_message_enabled &&
        this.notifications.sms_expiration_message.length > 60
      ) {
        this.errors.custom_expiration_length = this.$t(
          "errors.notifications.wa.custom_message_length",
        );
        this.validated = false;
      }
      if (
        this.notifications.sms_expiring_soon_message_enabled &&
        this.notifications.sms_expiring_soon_message.length > 60
      ) {
        this.errors.custom_expiring_soon_length = this.$t(
          "errors.notifications.wa.custom_message_length",
        );
        this.validated = false;
      }
      if (
        this.notifications.sms_renew_message_enabled &&
        this.notifications.sms_renew_message.length > 60
      ) {
        this.errors.custom_renew_length = this.$t(
          "errors.notifications.wa.custom_message_length",
        );
        this.validated = false;
      }
      if (
        this.notifications.sms_sham_renew_message_enabled &&
        this.notifications.sms_sham_renew_message.length > 60
      ) {
        this.errors.custom_sham_renew_length = this.$t(
          "errors.notifications.wa.custom_message_length",
        );
        this.validated = false;
      }
    },
  },
  components: { QrcodeVue },
};
</script>
